function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "X");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "warmups",
  transform: "translate(-69.000000, -11.000000)",
  stroke: "#7C8796"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/@",
  transform: "translate(70.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,8 C11,9.65733333 9.65666667,11 8,11 C6.34333333,11 5,9.65733333 5,8 C5,6.34333333 6.34333333,5 8,5 C9.65666667,5 11,6.34333333 11,8 L11,8 Z",
  id: "Stroke-121"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3333333,14.3333333 C11.1,15.18 9.608,15.6666667 8,15.6666667 C3.76533333,15.6666667 0.333333333,12.2346667 0.333333333,8 C0.333333333,3.766 3.76533333,0.333333333 8,0.333333333 C12.2346667,0.333333333 15.6666667,3.766 15.6666667,8 L15.6666667,8.66666667 C15.6666667,9.956 14.622,11 13.3333333,11 C12.0446667,11 11,9.956 11,8.66666667 L11,8",
  id: "Stroke-122"
})))));

var SvgAt = function SvgAt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/at.8ba046b0.svg";
export { ForwardRef as ReactComponent };